export const validateItsServices = (obj: any) => {
  const required = ['storeHash', 'pageType', 'cartId', 'gqlToken'];
  const missing = required.filter((k) => !Object.hasOwn(obj, k));

  return missing.length
    ? {
        ok: false,
        msg: `Missing required itsServices keys: ${missing.join(', ')}`,
      }
    : { ok: true, msg: '' };
};

export const validateStencilUtils = (utils: any) => {
  return !utils?.hooks
    ? { ok: false, msg: 'Missing stencilUtils.hooks' }
    : { ok: true, msg: '' };
};

export const validateNotExcludedItem = (mountId: string, attribute: string) => {
  const mount = document.getElementById(mountId);
  const productTitle = mount?.getAttribute(attribute) || '';
  const productTitleExclusions =
    window.itsServices?.productTitleExclusions || [];

  const hasExclusion = productTitleExclusions.some((exclusionText) => {
    const regex = new RegExp(`\\b${exclusionText}\\b`, 'i');
    const isMatch = regex.test(productTitle);

    return isMatch;
  });

  return hasExclusion
    ? { ok: false, msg: 'Product is excluded from services' }
    : { ok: true, msg: '' };
};
